import { InMemoryProvider, OpenFeature } from "@openfeature/react-sdk";

export default class FeatureFlags {
	constructor() {
		this.featureFlags = OpenFeature.getClient();
		this.publisherContext = (context) => {
			const env = process.env.PLUGIN_ENV;
			const disabledPublisherIds = [];

			if (disabledPublisherIds.includes(context.publisher_id)) {
				return "legacy";
			}
			return "plugin";
		};

		this.flagConfig = {
			"get-events-api": {
				disabled: false,
				variants: {
					plugin: true,
					legacy: false,
				},
				defaultVariant: "legacy",
				contextEvaluator: this.publisherContext,
			},
			"home-page-api": {
				variants: {
					plugin: true,
					legacy: false,
				},
				disabled: false,
				defaultVariant: "legacy",
				contextEvaluator: this.publisherContext,
			},
			"widget-api": {
				variants: {
					plugin: true,
					legacy: false,
				},
				disabled: false,
				defaultVariant: "legacy",
				contextEvaluator: this.publisherContext,
			},
			"recommended-api": {
				variants: {
					plugin: true,
					legacy: false,
				},
				disabled: false,
				defaultVariant: "legacy",
				contextEvaluator: this.publisherContext,
			},
			"featured-api": {
				variants: {
					plugin: true,
					legacy: false,
				},
				disabled: false,
				defaultVariant: "legacy",
				contextEvaluator: this.publisherContext,
			},
			"editor-picks-api": {
				variants: {
					plugin: true,
					legacy: false,
				},
				disabled: false,
				defaultVariant: "legacy",
				contextEvaluator: this.publisherContext,
			},
			"new-search": {
				variants: {
					plugin: true,
					legacy: false,
				},
				disabled: false,
				defaultVariant: "legacy",
				contextEvaluator: this.publisherContext,
			},
		};

		OpenFeature.setProvider(new InMemoryProvider(this.flagConfig));
	}

	async checkFlag({ flagName, context = {}, defaultValue = false }) {
		await OpenFeature.setContext(context);
		const flag = await this.featureFlags.getBooleanValue(
			flagName,
			defaultValue,
		);

		return flag;
	}
}
